/**
 * MobileTabBar.jsx
 * The bar along the bottom of a phone screen: the four screens reached for
 * most, and a Menu button that opens the full sidebar as a drawer.
 *
 * Hidden above 900px by mobile.css — the sidebar is always on screen there.
 *
 * Dependencies: Icons.jsx, react-router-dom
 */

import { NavLink } from 'react-router-dom';
import { Calendar, Chat, Home, Menu, Plus } from './Icons.jsx';

const TABS = [
  { to: '/', label: 'Home', icon: Home, end: true },
  { to: '/create', label: 'Create', icon: Plus, primary: true },
  { to: '/calendar', label: 'Calendar', icon: Calendar },
  { to: '/inbox', label: 'Inbox', icon: Chat, badge: 'inbox' },
];

export default function MobileTabBar({ waiting, menuOpen, onMenu }) {
  return (
    <nav className="tabbar" aria-label="Quick navigation">
      {TABS.map(({ to, label, icon: Icon, end, badge, primary }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          className={({ isActive }) =>
            `tabbar__item${primary ? ' tabbar__item--primary' : ''}${isActive ? ' is-active' : ''}`
          }
        >
          <span className="tabbar__icon">
            <Icon size={21} />
            {badge && waiting[badge] > 0 && (
              <span className="tabbar__count" aria-label={`${waiting[badge]} waiting for a reply`}>
                {waiting[badge] > 9 ? '9+' : waiting[badge]}
              </span>
            )}
          </span>
          {label}
        </NavLink>
      ))}

      <button
        type="button"
        className={`tabbar__item${menuOpen ? ' is-active' : ''}`}
        onClick={onMenu}
        aria-expanded={menuOpen}
        aria-controls="sidebar"
      >
        <span className="tabbar__icon">
          <Menu size={21} />
        </span>
        Menu
      </button>
    </nav>
  );
}
